import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getLanguagePreferLevelsByCountryIdQuery: DocumentNode = gql`
  query GetLanguagePreferLevelsByCountryId($countryId: String!) {
    languagePreferLevelsByCountryId(id: $countryId) {
      countryId,
      languageId,
      preferLevel,
    }
  }
`;
